export { createAnatomy } from "./create-anatomy"
export type { Anatomy, AnatomyPart, AnatomyInstance, AnatomyPartName } from "./create-anatomy"
